import { useState } from 'react';
import type { DeleteAccountUserRoleRequest, DeleteAccountUserRoleResponse } from 'vopay';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

/**
 * Direct Pattern hook for deleting an account-level user Role.
 * Hits POST /account/user-roles/delete. Backend cascades the deletion to
 * remove all user assignments for the role.
 */
export default function useDeleteAccountUserRole() {
  const [submitting, setSubmitting] = useState(false);

  async function deleteUserRole(
    params: DeleteAccountUserRoleRequest,
    bearer?: string,
  ): Promise<DeleteAccountUserRoleResponse> {
    try {
      setSubmitting(true);
      const res = await api.postDeleteAccountUserRole(params, undefined, bearer);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (error) {
      console.error('Delete account user role failed:', error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  }

  return { submitting, deleteUserRole };
}
